import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useParams, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { Card, CardBody, Col, Container, Row, Table, Button } from "reactstrap"
import { isEmpty, map } from "lodash"
import Spinners from "components/Common/Spinner"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//Import Image
import logo from "../../assets/images/logo-dark.png"
import logoLight from "../../assets/images/logo-light.png"
import {
  getCajaReciboPago as onGetCajaReciboPago,
  postCajaEnvioRecibo as onPostCajaEnvioRecibo,
} from "store/actions"
//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  useAuthIsAuthenticated,
  useAuthIdPersonaAuthenticated,
  useCajaError,
  useCajaoRecibo,
  useCajaId_Recibo_Pago,
  useCajaDataArmarReciboPago,
  useCajaIsLoading,
  useCajaMensajeExitoso,
} from "store/selectors"

const Recibo = props => {
  //meta title
  document.title = "Recibo Pago | CampusVirtual.mx"

  const history = useNavigate()

  // Aqui recibo el id_Alumno del QueryString
  const { idRecibo } = useParams()

  const dispatch = useDispatch()

  const isLoading = useCajaIsLoading()
  const isAuthenticated = useAuthIsAuthenticated()
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const oRecibo = useCajaoRecibo()
  const id_Recibo_Pago = useCajaId_Recibo_Pago()
  const error = useCajaError()
  const data = useCajaDataArmarReciboPago()
  const mensajeExitoso = useCajaMensajeExitoso()

  const [idReciboEnviar, setIdreciboEnviar] = useState(-1)

  const params = props.router.params

  useEffect(() => {
    if (id_Recibo_Pago > 0) {
      setIdreciboEnviar(id_Recibo_Pago)
      dispatch(
        onGetCajaReciboPago({
          nombreSolicitud: "getdatareciboxidrecibo",
          idPersona: idPersonaAuthenticated,
          idReciboPago: id_Recibo_Pago,
        })
      )
    }
  }, [dispatch, onGetCajaReciboPago, id_Recibo_Pago, idRecibo])

  useEffect(() => {
    if (error && error.length) {
      toast.error(error, {
        autoClose: 2000,
      })
    }
  }, [dispatch, error])

  useEffect(() => {
    if (mensajeExitoso && mensajeExitoso.length) {
      console.log("useEffect::mensajeExitoso:", mensajeExitoso)
      toast.success(mensajeExitoso, {
        autoClose: 2000,
      })
      setTimeout(() => {
        history("/caja")
      }, 2000)
    }
  }, [mensajeExitoso])

  const handleEnviarButton = id => {
    if (isAuthenticated && idPersonaAuthenticated > 0) {
      dispatch(
        onPostCajaEnvioRecibo({
          nombreSolicitud: "enviarorecibo",
          idPersona: idPersonaAuthenticated,
          idReciboPago: id,
        })
      )
    }
  }

  //Print the Invoice
  const printInvoice = () => {
    window.print()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Recibo" breadcrumbItem="Detalle Recibo" />
          <Row>
            <Col lg="12">
              <Card>
                <ToastContainer />
                {isLoading ? (
                  <Spinners setLoading={() => {}} />
                ) : (
                  <CardBody>
                    <div className="invoice-title">
                      <h4 className="float-end font-size-16">
                        Recibo # {data ? data.oReciboPago?.id_Recibo_Pago : -1}
                      </h4>
                      <div className="auth-logo mb-4">
                        <img
                          src={logo}
                          alt="logo-dark"
                          className="logo-dark-element"
                          height="20"
                        />
                        <img
                          src={logoLight}
                          alt="logo-light"
                          className="logo-light-element"
                          height="20"
                        />
                      </div>
                    </div>
                    <hr />
                    <Row>
                      <Col sm="6">
                        <address>
                          <strong>Alumno:</strong>
                          <br />
                          <React.Fragment>
                            <span>
                              {data
                                ? data.oPersona
                                    ?.apellidopaterno_apellido_materno_nombre
                                : ""}
                            </span>
                            <br />
                            {data ? data.oPersona?.Email_Personal : ""}
                          </React.Fragment>
                        </address>
                      </Col>
                      <Col sm="6" className="text-sm-end">
                        <address>
                          <strong>Dirección:</strong>
                          <br />
                          <React.Fragment>
                            <span>
                              {data ? data.oCampus?.oDireccion.Calle : ""}{" "}
                              {data
                                ? data.oCampus?.oDireccion.Numero_Exterior
                                : ""}{" "}
                              {data
                                ? data.oCampus?.oDireccion.Numero_Interior
                                : ""}
                            </span>
                            <br />
                            <span>
                              {data
                                ? data.oCampus?.oDireccion.Telefono_Fijo
                                : ""}{" "}
                              {data
                                ? data.oCampus?.oDireccion.Telefono_Fijo2
                                : ""}
                            </span>
                            <br />
                          </React.Fragment>
                        </address>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" className="mt-3">
                        <address>
                          <strong>Método de Pago:</strong>
                          <br />
                          {data ? data.oReciboPago?.Nombre_Forma_Pago : ""}
                          <br />
                          {/* {data.oPersona?.Email_Personal} */}
                        </address>
                      </Col>
                      <Col sm="6" className="mt-3 text-sm-end">
                        <address>
                          <strong>Fecha Pago:</strong>
                          <br />
                          {new Date(
                            data ? data.oReciboPago?.Fecha_Recibo : "2024-01-01"
                          ).toLocaleDateString("es-MX")}
                        </address>
                      </Col>
                    </Row>
                    <div className="py-2 mt-3">
                      <h3 className="font-size-15 fw-bold">Abonos</h3>
                    </div>
                    <div className="table-responsive">
                      <Table className="table-nowrap">
                        <thead>
                          <tr>
                            <th style={{ width: "70px" }}>id</th>
                            <th>Concepto</th>
                            <th className="text-end">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          {map(
                            data ? data.oReciboPago?.Lista_Abonos : [],
                            (item, key) => (
                              <tr key={key}>
                                <td>{item.id_Abono}</td>
                                <td>{item.Concepto}</td>
                                <td className="text-end">
                                  {item.Cantidad.toLocaleString("es-MX", {
                                    style: "currency",
                                    currency: "MXN",
                                  })}
                                </td>
                              </tr>
                            )
                          )}
                          <tr>
                            <td colSpan="2" className="text-end">
                              Sub Total
                            </td>
                            <td className="text-end">
                              {data
                                ? data.oReciboPago?.Cantidad_Recibo
                                : "2024-01-01".toLocaleString("es-MX", {
                                    style: "currency",
                                    currency: "MXN",
                                  })}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="border-0 text-end">
                              <strong>Impuestos</strong>
                            </td>
                            <td className="border-0 text-end">
                              {data
                                ? data.oReciboPago?.Impuestos
                                : "2024-01-01".toLocaleString("es-MX", {
                                    style: "currency",
                                    currency: "MXN",
                                  })}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="border-0 text-end">
                              <strong>Total</strong>
                            </td>
                            <td className="border-0 text-end">
                              <h4 className="m-0">
                                {data
                                  ? data.oReciboPago?.Cantidad_Recibo
                                  : "2024-01-01".toLocaleString("es-MX", {
                                      style: "currency",
                                      currency: "MXN",
                                    })}
                              </h4>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <div className="d-print-none">
                      <div className="float-end">
                        <Link
                          to="#"
                          onClick={printInvoice}
                          className="btn btn-success  me-2"
                        >
                          <i className="fa fa-print" />
                        </Link>
                        {/* <Link
                          to="#"
                          onClick={handleEnviarButton}
                          className="btn btn-primary w-md "
                        >
                          Enviar
                        </Link> */}
                        <Button
                          color="primary"
                          className="btn waves-effect waves-light me-1 w-md"
                          onClick={() => {
                            handleEnviarButton(idReciboEnviar)
                          }}
                        >
                          Enviar
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Recibo.propTypes = {
  match: PropTypes.any,
}

export default withRouter(Recibo)
